import { Component, OnInit, Input, TemplateRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { OfferService } from '../../../shared/providers/offer.service';
import { IOfferDocsOutputModel } from '../../../shared/models/OfferDetailOutputModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { IFileUpload, IPropertyFileUpload } from '../../../shared/models/fileupload';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { Observable, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../../../shared/providers/common.service';
import { LookUp } from '../../../shared/enum/enum';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { DashboardService } from '../../../shared/providers/dashboard.service';



//import { saveAs } from 'file-saver';

@Component({
  selector: 'app-offer-files-tab',
  templateUrl: './offer-files-tab.component.html'
})

export class OfferFilesTabComponent implements OnInit {

  LeadOffersDocsList: IOfferDocsOutputModel[];
  docCategories: ILookUp[];
  errorMessage: string;
  documentId: number;
  user: any;
  showRemoveButton: boolean = false;
  errorMessageForDocs: string;
  selectedFiles: string[] = [];
  selectedFilesForDocs: string[] = [];
  inputFileUpload = {} as IFileUpload;
  clearFiles: number = 0;
  modalRef: BsModalRef;
  modalRefEdit: BsModalRef;
  modalRefFile: BsModalRef;
  @Input() inputOfferGuid: string = "";
  @Input() propertyId: number = 0;
  @Input() RefreshTab: string = "";
  @Input() fileTypes: string;
  @Input() BackgroundFileStoring: number = 0;
  @Input() fromDealMaking: boolean = false;
  @Output() fileUploaded = new EventEmitter();
  @Input() modalRefUpload: BsModalRef;
  uploadedFiles: IPropertyFileUpload[] = [];
  fileExtensionType = 'document';
  fileUploadType = 'multiple';
  accordianLeadOfferDoclst = [];
  filterOfferList = [];
  fileList = [];
  subscription: Subscription = new Subscription();
  IsFileUploadConfirmed: boolean = false;
  @ViewChild('UploadConfirmation') uploadConfirmation: TemplateRef<any>;
  modalRefuploadConfirmation: BsModalRef;
  constructor(private modalService: BsModalService, private authService: AuthenticationService, private router: Router, private _auth0: AuthService, private offerService: OfferService, private _toastService: ToastService, private http: HttpClient, private Loader: LoaderService, private Toast: ToastService, private _fileUploadService: FileUploadService, public Validation: ValidationService, private _propertyManagementService: PropertyManagementService, private _commonService: CommonService, private _dashboardService: DashboardService) { }
  offerGuid = '';
  ngOnInit() {
    this.offerGuid = this.inputOfferGuid;
    if (this.offerGuid != null) {
      this.bindTable();
      if (this.propertyId == 0) {
        if (this.fromDealMaking) {
          this._propertyManagementService.getFileCategories(6810)
            .subscribe(response => {
              this.docCategories = response.map(o => {
                return { id: o.Id, description: o.Description };
              });
            });
        }
        else {
          this._propertyManagementService.getFileCategories(6807)
            .subscribe(response => {
              this.docCategories = response.map(o => {
                return { id: o.Id, description: o.Description };
              });
            });
        }
      }
      else {
        this._propertyManagementService.getFileCategories(6805).subscribe(response => {
          this.docCategories = response.map(o => {
            return { id: o.Id, description: o.Description };
          });
        });
      }
      this.user = this.authService.user;
      if (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.showRemoveButton = true;
      }
      //this._propertyManagementService.getDocumentCategories().subscribe(response => {
      //    this.docCategories = response.map(o => {
      //        return { id: o.Id, description: o.Description };
      //    });
      //});
    }

    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(f => f.ImageStatus == '' || f.ImageStatus == null && f.sourceUrl == this.router.url && f.RefreshTab == this.RefreshTab);
      if (ongoingList != null && ongoingList.length > 0) {
        localStorage.setItem('currentFileRefreshTab', this.RefreshTab);
      }
      else if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
    }
        
    this.subscription.add(this._auth0.customObservable.subscribe((res) => {
        if (res.sourceUrl == this.router.url && localStorage.getItem('currentFileRefreshTab') == this.RefreshTab && res.refreshTab == this.RefreshTab) {
          this.bindTable();
        }
      }
      ));
  }
  latestId = 0;
  bindTable() {
    this.offerService.getOfferDocsList(this.offerGuid).subscribe(response => {
      if (response) {
        if (response.length > 0) {
          this.latestId = response[0].LatestId;
        }
        this.LeadOffersDocsList = response;
        this.LeadOffersDocsList.forEach(item => {
          item.Date = this.Validation.convertUTCDateToLocalDate(item.Date);
        });
        this.accordianLeadOfferDoclst = Array.from(new Set(this.LeadOffersDocsList.map((item: any) => item.Category)));
        let i = 0;
        this.filterOfferList = [];
        this.fileList = [];
        this.accordianLeadOfferDoclst.forEach(data => {
          this.filterOfferList.push({
            Category: data,
            Active: 0,
            data: [],
            showChild: false
          });
          this.LeadOffersDocsList.forEach(leadData => {
            if (data == leadData['Category']) {
              this.filterOfferList[i].data.push({
                Category: leadData['Category'],
                DocumentId: leadData['DocumentId'],
                Date: leadData['Date'],
                FileName: leadData['FileName'],
                LatestId: leadData['LatestId'],
                Path: leadData['Path'],
                UploadedBy: leadData['UploadedBy']
              });
              this.fileList.push({
                Category: leadData['Category'],
                DocumentId: leadData['DocumentId'],
                Date: leadData['Date'],
                FileName: leadData['FileName'],
                LatestId: leadData['LatestId'],
                Path: leadData['Path'],
                UploadedBy: leadData['UploadedBy'],
                CategoryId: leadData['CategoryId']
              })
            }
          });
          i = i + 1;
        });
      }
    });
  }

  filesCollection = [];
  categoryList = [];

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      var ext = item["name"].toUpperCase().split('.').pop() || item["name"];
      if (item["type"] === 'application/pdf') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/vnd.ms-excel' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/msword' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'text/plain') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if ((item["type"] === 'image/x-dwg') || (ext === "DWG")) {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else {
        this._toastService.addToast({
          title: 'Error Extension',
          msg: `Please upload .pdf/.xlsx/.xls/.docx/.doc/.txt/.dwg files`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });
  }
  removeImage(fileIndex: number, event: any) {
    if (fileIndex > -1) {
      //this.selectedFiles.splice(fileIndex, 1);
      this.filesCollection.splice(fileIndex, 1);
    }
  }
  onFilesClear() {
    this.clearFiles++;
    this.selectedFiles = [];
    this.filesCollection = [];
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  documentPreview: BsModalRef;
  docPreview: any;

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  categoryId: number;
  UpdateDocCategory() {
    this._dashboardService.saveBOEPropertyDocumentCategory(this.editFileId, this.categoryId, true, this.user.Id).subscribe(res => {
      this.modalRefEdit.hide();
      this.bindTable();
      this._toastService.addToast({ title: 'Success', msg: 'Document category updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    })
  }

  openModal(template: TemplateRef<any>, classes: any, documentId: number, i: any) {

    this.modalRef = this.modalService.show(template, { class: classes });
    this.documentId = documentId;
  }
  onRemoveDocument() {
    this._propertyManagementService.deleteDocument(this.documentId, this.user.Id).subscribe(response => {
      this.bindTable();
      if (response.toString() === 'true') {
        this._toastService.addToast({
          title: 'Success',
          msg: 'Document deleted!',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });



      } else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Image could not be deleted',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });

  }

  uploadFiles() {
    this.Loader.display(true);
    let valid = true;
    //if (this.modalRefuploadConfirmation !== undefined) {
    //  this.modalRefuploadConfirmation.hide();
    //}
    for (let i = 0; i < this.filesCollection.length; i++) {
      if (parseInt(this.filesCollection[i]["category"]) === 0) {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Catogory", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.Loader.display(false);
        valid = false;
        break;
      }
    }
    if (valid) {
   /*   if (this.IsFileUploadConfirmed) {*/
       /* this.IsFileUploadConfirmed = false;*/
        let uploadCount = 1;
        this.filesCollection.forEach(item => {
          let fileToUpload = [];
          fileToUpload.push(item["file"]);
          this.uploadedFiles.push({
            id: 0,
            objectId: this.propertyId > 0 ? this.propertyId : this.latestId,
            type: 'Documents',
            documentName: item["name"],
            fileCategoryId: item["category"],
            objectTypeId: this.propertyId > 0 ? 302 : 303,
            FileContent: null,
            isDefault: false,
            ImageGuid: this.newGuid(),
            PropertyGuid: '',
            ImageStatus: '',
            OfferGuid: this.inputOfferGuid,
            fileToUpload: fileToUpload,
            sourceUrl: this.router.url,
            RefreshTab: this.RefreshTab
          });
          this.inputFileUpload.documentName = item["name"];
          //this.inputFileUpload.fileCategoryId = item["category"];
          //this.inputFileUpload.id = 0;
          //this.inputFileUpload.objectId = this.propertyId > 0 ? this.propertyId : this.latestId;
          //this.inputFileUpload.objectTypeId = this.propertyId > 0 ? 302 : 303;
          //this.inputFileUpload.type = "Documents";
          //this.inputFileUpload.OfferGuid = this.inputOfferGuid;
          //let fileToUpload = [];
          //fileToUpload.push(item["file"]);
          //  this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
          //    if (res != null) {
          //      if (uploadCount == this.filesCollection.length) {
          //        if (this.propertyId == 0) {
          //          this.bindTable();
          //        }
          //        else {
          //          this.fileUploaded.emit();
          //        }

          //        this.onFilesClear();
          //        this.Loader.display(false);
          //        this.Toast.addToast({ title: 'Success', msg: "Files Uploaded Successfully", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

          //      }
          //      uploadCount++;
          //    }
          //  });
        });
        this.clearFiles++;
        if (this.uploadedFiles != null) {
          this.onFilesClear();
          this.Loader.display(false);
          this.imageupload();
          if (this.modalRefUpload != undefined) {
            this.modalRefUpload.hide();
          }
          this.Toast.addToast({ title: '', msg: "File uploads are in progress, please don't reload or close the website until complete.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
        }
    /*  }*/
      //else {
      //  this.Loader.display(false);
      //  this.IsFileUploadConfirmed = true;
      //  this.modalRefuploadConfirmation = this.modalService.show(this.uploadConfirmation, { class: 'deletemodal' });
      //}
    }
  }
  openAccordian(index) {
    if (index.Active == 1) {
      index.Active = 0;
    }
    else {
      index.Active = 1;
    }
  }

  editFileId: number;

  openEditModal(template: TemplateRef<any>, classes: any, id: number, category: number) {
    this.categoryId = category;
    this.editFileId = id;
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  imageupload() {
    localStorage.setItem('currentFileRefreshTab', this.RefreshTab);
    this._auth0.FileUpload(this.uploadedFiles);
    this.uploadedFiles = [];
  }
  toggle_child(data) {
    this.filterOfferList.map(item => {
      if (data === item) {
        item.showChild = !item.showChild;
      }
      else {
        item.showChild = false;
      }
    })
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  OpenAddFileSlider(template: TemplateRef<any>, classes: any) {
    this.modalRefUpload = this.modalService.show(template, { class: classes });
  }
  CloseFile() {
    if (this.modalRefUpload != undefined) {
      this.modalRefUpload.hide();
    }
  }

  //private saveToFileSystem(response) {
  //    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
  //    const parts: string[] = contentDispositionHeader.split(';');
  //    const filename = parts[1].split('=')[1];
  //    const blob = new Blob([response._body], { type: 'text/plain' });
  //    saveAs(blob, filename);
  //}

  //download() {

  //    const headers = new HttpHeaders();
  //    headers.append('Accept', 'text/plain');
  //    headers.append('Access-Control-Allow-Origin', '*');
  //    headers.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
  //    this.http.get('http://localhost:50293/api/upload/file/1/test/2', { headers: headers })
  //        .toPromise()
  //        .then(response => this.saveToFileSystem(response));

  //    //this._fileUploadService.downloadDoc("0").subscribe(result => {
  //    //    var url = window.URL.createObjectURL(result);
  //    //   // window.open(url);

  //    //    const downloadLink = document.createElement("a");
  //    //    downloadLink.style.display = "none";
  //    //    document.body.appendChild(downloadLink);
  //    //    downloadLink.setAttribute("href", url);
  //    //    downloadLink.setAttribute("download", "loi.pdf");
  //    //    downloadLink.click();
  //    //    document.body.removeChild(downloadLink);
  //    //});
  //}
}

